module.exports = __webpack_public_path__ + "img/cancel.de39bb6b.svg";